import { pluginFactory } from '../utils/plugins';
import { VBHoverPlugin } from './hover';
import { VBModalPlugin } from './modal';
import { VBPopoverPlugin } from './popover';
import { VBScrollspyPlugin } from './scrollspy';
import { VBTogglePlugin } from './toggle';
import { VBTooltipPlugin } from './tooltip';
import { VBVisiblePlugin } from './visible'; // Main plugin for installing all directive plugins

export var directivesPlugin = /*#__PURE__*/pluginFactory({
  plugins: {
    VBHoverPlugin: VBHoverPlugin,
    VBModalPlugin: VBModalPlugin,
    VBPopoverPlugin: VBPopoverPlugin,
    VBScrollspyPlugin: VBScrollspyPlugin,
    VBTogglePlugin: VBTogglePlugin,
    VBTooltipPlugin: VBTooltipPlugin,
    VBVisiblePlugin: VBVisiblePlugin
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/directives/index.js
// module id = ZsCA
// module chunks = 5